import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { notification } from 'antd';

// Create the Notification Context
const NotificationContext = createContext();

// Notification Provider Component
export const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  // Open Notification Function
  const openNotification = (
    placement,
    title,
    description,
    success,
    options = {}
  ) => {
    const config = {
      message: title,
      description,
      placement,
      ...options
    };

    success ? api.success(config) : api.error(config);
  };

  // Open Message Function
  const openMessage = (placement, title, description, options = {}) => {
    api.info({
      message: title || `Message ${placement}`,
      description: description || 'This is the content of the message.',
      placement,
      ...options
    });
  };

  // Return the context provider
  return (
    <>
      {contextHolder}
      <NotificationContext.Provider value={{ openNotification, openMessage }}>
        {children}
      </NotificationContext.Provider>
    </>
  );
};
NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired
};

// Custom Hook to use Notification Context
export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      'useNotification must be used within a NotificationProvider'
    );
  }
  return context;
};
